export class ContactListContacts {
  idContactList: number;
  name: string;
  customFields: CustomFieldJson[];
  contacts: ContactListContact[];

  constructor(idContactList: number, name: string, customFields: CustomFieldJson[], contacts: ContactListContact[]) {
    this.idContactList = idContactList ? idContactList : 0;
    this.name = name ? name : null;
    this.customFields = customFields ? customFields : [];
    this.contacts = contacts ? contacts : [];
  }
}

export class ContactListContact {
  idContactContactList: number;
  id: number;
  email: string;
  phone: string;
  customFieldsJson: CustomFieldJson[];

  constructor(idContactContactList?: number, id?: number, email?: string, phone?: string, customFieldJson?: CustomFieldJson[]) {
    this.idContactContactList = idContactContactList ? idContactContactList : 0;
    this.id = id ? id : 0;
    this.email = email ? email : null;
    this.phone = phone ? phone : null;
    this.customFieldsJson = customFieldJson ? customFieldJson : [];
  }
}

export class CustomFieldJson {
  idCustomField: string;
  value: string;
  type: string;
  name: string;
  isRequired: boolean;

  constructor(idCustomField: string, value: string, type: string, name: string, isRequired: boolean) {
    this.idCustomField = idCustomField;
    this.value = value;
    this.type = type;
    this.name = name;
    this.isRequired = isRequired;
  }
}

export class ContactListContactModel {
  idContactList: number;
  idContactContactList: number;
  id: number;
  email: string;
  phone: string;
  customFieldsJson: CustomFieldJson[];

  constructor(idContactList?: number, idContactContactList?: number, id?: number, email?: string, phone?: string, customFieldJson?: CustomFieldJson[]) {
    this.idContactList = idContactList;
    this.idContactContactList = idContactContactList;
    this.id = id;
    this.email = email;
    this.phone = phone;
    this.customFieldsJson = customFieldJson
  }
}

